import { UPDATE_RESPONSIVE_STATE } from "app/actionTypes";

export const updateResponsiveState = resolution => {
	return {
		type: UPDATE_RESPONSIVE_STATE,
		resolution,
	};
};
